import {MutableRefObject, useEffect, useRef, useState} from 'react';

import {insertText} from '../utils/editorCommands';

export function useEditorEmoji(
  editorRef: MutableRefObject<HTMLDivElement | null>,
  selectionRef: MutableRefObject<Range | null>,
  syncEditorState: () => void,
  updateMetadata: () => void
) {
  const pickerRef = useRef<HTMLDivElement>(null);
  const [isEmojiPickerOpen, setIsEmojiPickerOpen] = useState(false);
  const [activeEmojiCategory, setActiveEmojiCategory] = useState(0);

  useEffect(() => {
    if (!isEmojiPickerOpen) {
      return;
    }

    const handleOutsideClick = (event: globalThis.MouseEvent) => {
      if (!pickerRef.current) {
        return;
      }

      if (!pickerRef.current.contains(event.target as Node)) {
        setIsEmojiPickerOpen(false);
      }
    };

    document.addEventListener('mousedown', handleOutsideClick);

    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, [isEmojiPickerOpen]);

  const handleEmojiInsert = (emoji: string) => {
    insertText(editorRef.current, selectionRef, emoji);
    syncEditorState();
    updateMetadata();
    setIsEmojiPickerOpen(false);
  };

  return {
    pickerRef,
    isEmojiPickerOpen,
    setIsEmojiPickerOpen,
    activeEmojiCategory,
    setActiveEmojiCategory,
    handleEmojiInsert,
  };
}
